import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { useSlugParam } from "@/common/hooks/useParam";
import { SegmentViewType } from "@/company/components/SegmentViewToggle";

export function useSegmentRouteParam() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { segmentId } = useSlugParam("segment");

  // Get view type from URL params, default to "companies"
  const viewType = useMemo(() => {
    const view = searchParams.get("view");
    return (view === "users" ? "users" : "companies") as SegmentViewType;
  }, [searchParams]);

  const setViewType = (newViewType: SegmentViewType) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (newViewType === "companies") {
      newSearchParams.delete("view");
    } else {
      newSearchParams.set("view", newViewType);
    }

    // when changing view type, delete sortBy param
    // columns are not the same for companies and users
    newSearchParams.delete("sorting");

    setSearchParams(newSearchParams);
  };

  return {
    segmentId,
    viewType,
    setViewType,
  };
}
